module.exports = __webpack_public_path__ + "media/images/landing__teaser__boxDeco--desktop-b989211f8f19e9b6b5ae69c68d41fb02.png";